import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import { useState, useRef, useEffect } from 'react';

/**
 * This hook detect when a click is outside of the ref component and close it.
 */

function useComponentVisible(initialIsVisible, callback) {
  var _useState = useState(initialIsVisible),
    _useState2 = _slicedToArray(_useState, 2),
    isComponentVisible = _useState2[0],
    setIsComponentVisible = _useState2[1];
  var ref = useRef(null);
  var handleClickOutside = function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
      callback();
    }
  };
  useEffect(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  /**
   * For its use, these keys must be imported into the component to hide / show.
   */

  return {
    ref: ref,
    isComponentVisible: isComponentVisible,
    setIsComponentVisible: setIsComponentVisible
  };
}

var useKeyPress = function useKeyPress(targetKey) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyPressed = _useState2[0],
    setKeyPressed = _useState2[1];
  function downHandler(_ref) {
    var key = _ref.key;
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }
  var upHandler = function upHandler(_ref2) {
    var key = _ref2.key;
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };
  useEffect(function () {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return function () {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  });
  return keyPressed;
};

export { useComponentVisible as a, useKeyPress as u };
//# sourceMappingURL=useKeyPress-dea8da08.js.map
